import { Injectable, Inject, Injector } from "@angular/core";
import { MdDialog, MdDialogConfig, ComponentType } from "@angular/material";
import { Observable, Subscription } from 'rxjs';
import { DialogResultComponent } from "../shared/component/dialog-result.component";
import { AppModule } from "../app.module";

@Injectable()
export class DialogService {
    private _dialog: MdDialog;
    subDialog: Subscription;
    constructor() {
        this._dialog = AppModule.injector.get(MdDialog);
    }

    open<T>(template: ComponentType<T>, parametros: any = null, width: any = null) {
        let config = new MdDialogConfig();
        config.disableClose = true;
        config.data = parametros;
        config.width = width;
        return this._dialog.open(template, config);
    }

    confirm(title: string, texto: string, callbackSim): any {
        let config = new MdDialogConfig();
        config.data = {
            "title": title, "text": texto,
            "buttons": [
                { "title": "Sim", "Action": "Sim" },
                { "title": "Não", "Action": "Nao" }
            ]
        };

        config.hasBackdrop = false;
        config.disableClose = true;

        const dialogRef = this._dialog.open(DialogResultComponent, config);
        this.subDialog = dialogRef.afterClosed().subscribe((result) => {
            if (result.Action == "Sim")
                callbackSim();
        });
    }

    alert(title: string, texto: string, callbackSim): any {
        let config = new MdDialogConfig();
        config.data = {
            "title": title, "text": texto,
            "buttons": [
                { "title": "Ok", "Action": "Ok" }                
            ]
        };

        config.hasBackdrop = false;
        config.disableClose = true;

        const dialogRef = this._dialog.open(DialogResultComponent, config);
        this.subDialog = dialogRef.afterClosed().subscribe((result) => {
            if (result.Action == "Ok")
                callbackSim();
        });
    }

    ngOnDestroy() {
        this.subDialog.unsubscribe();
    }
}


// WEBPACK FOOTER //
// C:/Users/anderson.oshiro/Projetos/Azure/Ipcorp.PortalCobranca/Web/Ipcorp.PortalCobranca.Web/src/app/services/dialog.service.ts